import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutOrgUnitStaffData = (orgUnitId, personId, roleGroupId, staffObj, state, setState) => {
  if (state.isSaving !== true && orgUnitId && personId && roleGroupId > 0 && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const roleGroupIdForUrl = roleGroupId ? encodeURIComponent(roleGroupId) : 'NaN';
    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;

    const url = `/OrgUnit/${orgUnitIdForUrl}/staff/roleGroup/${roleGroupIdForUrl}/person/${personIdForUrl}`;
    CommonHttpHelper(url, 'PUT', staffObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutOrgUnitStaffData;